import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailerTeamManagementSetRoleAndPermissionsClick } from "@faire/web-api--source/events/retailerTeamManagement/click/setRoleAndPermissions";
import myTeamPermissions from "@faire/web-api--source/routes/retailer/settings/my-team/permissions/user_token";
import React from "react";

interface IProps {
  email: string;
  accountToken: string;
}

export const InviteUserToast: React.FC<IProps> = ({ email, accountToken }) => {
  return (
    <Column align="baseline">
      <Typography
        truncate
        style={{
          width: "250px",
        }}
      >
        <StrictLocalMsg
          defaultMessage="Invite sent to {userEmailAddress}."
          values={{
            userEmailAddress: email,
          }}
          description={{
            text: "text for toast that lets user know that they have sent an invitation to join the platform",
            img: "https://cdn.faire.com/fastly/e32ef7439a697df20a0636d68611aa03ab5fa15d02fbb3bd0660f310292a866c.png",
          }}
        />
      </Typography>
      <Button
        tertiaryColor={Core.text.inverse}
        variant="tertiary"
        linkTo={myTeamPermissions(accountToken)}
        onClick={trackRetailerTeamManagementSetRoleAndPermissionsClick}
      >
        <StrictLocalMsg defaultMessage="Set role and permissions" />
      </Button>
    </Column>
  );
};
